import { Outlet } from 'react-router-dom';

import Spinner from '~/common/components/Spinner';
import useGetLoanSummary from '~/common/hooks/useGetLoanSummary';
import {
  useNavFeatureFlags,
  useNavFeatureFlagsQuery,
} from '~/common/hooks/useNavFeatureFlags';
import { useProductAndCategories } from '~/common/hooks/useProductAndCategories';
import useUrl from '~/common/hooks/useUrl';

import PageLayout from '../../GlobalLayout/PageLayout/PageLayout';
import NavItemWrapper from '../components/NavItemWrapper';
import SelectedCategoryNavContainer from '../components/SelectedCategoryNavContainer';
import { NavWrapper } from '../components/Styled';

const SummaryNav = () => {
  const featureFlags = useNavFeatureFlags();
  const { isReadOnly } = useUrl();

  const { filteredCategories } = useProductAndCategories();

  return (
    <NavWrapper>
      <SelectedCategoryNavContainer>
        {filteredCategories.map(
          ({ flagName, label, to }) =>
            featureFlags[flagName] && (
              <NavItemWrapper
                key={label}
                label={label}
                to={isReadOnly ? `${to}/readOnly` : to}
              />
            ),
        )}
      </SelectedCategoryNavContainer>
    </NavWrapper>
  );
};

export default function SummaryWrapper() {
  const { isLoading } = useNavFeatureFlagsQuery();
  useGetLoanSummary();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <PageLayout
      leftDrawerContent={null}
      topNav={<SummaryNav />}
      miscUtilityContainers={null}
    >
      <Outlet />
    </PageLayout>
  );
}
